var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("brick-square-base", [
    _c(
      "div",
      { staticClass: "brick-icon" },
      [_c("brick-icon", { attrs: { "brick-type": _vm.brickType } })],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "brick-title" }, [
      _vm._v("\n        " + _vm._s(_vm.displayName) + "\n    ")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }